import { createSlice } from "@reduxjs/toolkit";

// Slice
const announcementsSlice = createSlice({
  name: "announcements",
  initialState: {
    announcements: [],
    latestAnnouncement: null,
    loading: true,
    error: null,
  },
  reducers: {
    setAnnouncements: (state, action) => {
      state.announcements = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLatestAnnouncement: (state, action) => {
      state.latestAnnouncement = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

// Actions
export const {
  setAnnouncements,
  setLatestAnnouncement,
  setLoading,
  setError,
} = announcementsSlice.actions;

// Reducer
export default announcementsSlice.reducer;
